module.exports = __webpack_public_path__ + "static/media/link.596eec3f.png";